import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type React from 'react';
export type PillProps = {
  'aria-controls'?: string;
  'aria-expanded'?: boolean;
  'aria-haspopup'?: boolean | 'grid' | 'dialog' | 'menu' | 'true' | 'false' | 'listbox' | 'tree';
  children?: React.ReactNode;
  disabled?: boolean;
  label?: () => void;
  onClick?: () => void;
};
type PillComponentProps = PillProps & React.ButtonHTMLAttributes<HTMLButtonElement>;
const Pill = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      type: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const type = t1 === undefined ? "button" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cx("fp-filter-pill text-label-2 flex items-center gap-1 whitespace-nowrap h-8 py-2 pr-3 pl-2 rounded-(--filter-pill-radius) border border-solid border-tertiary enabled:cursor-pointer enabled:bg-primary enabled:text-secondary enabled:hover:bg-hover-control disabled:bg-secondary disabled:text-quaternary", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t2 || $[10] !== type) {
    t3 = <button type={type} className={t2} {...props}>{children}</button>;
    $[7] = children;
    $[8] = props;
    $[9] = t2;
    $[10] = type;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default Pill;